// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ob1-price-amount-custom[data-v-facb952c]{color:#000}", "",{"version":3,"sources":["webpack://./src/main/webapp/WEB-INF/views/common/components/ob1/DevicePrice.vue"],"names":[],"mappings":"AAEA,0CACI,UAAA","sourcesContent":["\n\n.ob1-price-amount-custom {\n    color: black;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
